module.exports = __webpack_public_path__ + "img/photo-hit-2020.ceb70b7e.jpg";